var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ag-status-name-value"},[_c('div',{staticClass:"component"},[_vm._v(" Lignes : "),_c('span',{staticClass:"text-black"},[_vm._v(_vm._s(_vm.displayedRowCount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }